import { atom } from "jotai";

export const AddPeopleSearch_Atom = atom<string>("");
export const currentAddPatronsSlotIdAtom = atom<string>("");
